import { CourseFromServerType } from "seneca-common/features/course/state/models/state/courses/course/Course";

import queryActionTypes from "../action-types";

type BucketType = {
  key: string;
  doc_count: number;
};

export type QueryResultsType = {
  hits: Array<{
    _source: CourseFromServerType;
  }>;
  aggregations: Record<
    string,
    {
      buckets: Array<BucketType>;
    }
  >;
};

export function makeActions(actionTypes: typeof queryActionTypes) {
  const receiveQueryResults = (results: QueryResultsType) => {
    return {
      type: actionTypes.RECEIVE_QUERY_RESULTS,
      payload: results
    };
  };

  return {
    receiveQueryResults
  };
}

export const { receiveQueryResults } = makeActions(queryActionTypes);
